import 'core-js'
import 'whatwg-fetch'
import 'abortcontroller-polyfill/dist/polyfill-patch-fetch'
// Order matters: AbortController needs fetch which needs Promise (provided by core-js).
import 'md-gum-polyfill'

import Uppy from '@uppy/core'
// import Transloadit from '@uppy/transloadit'
import Dashboard from '@uppy/dashboard'
import AwsS3 from "@uppy/aws-s3"
import {
    registerStereoAudioPreProcessor,
    isStereoValidationFailureError
} from '../shared/stereo_audio_preprocessor'
import {
    AUDIO_ALLOWED_FILE_TYPES,
    AUDIO_ALLOWED_FILE_TYPES_MESSAGE
} from '../shared/audio_upload_options'
import { mapPlacementEpisode, withConversionAlert } from './bitrate_conversion'
import { pageWindowItems } from '../shared/pagination_window'

require('@uppy/core/dist/style.min.css')
require('@uppy/dashboard/dist/style.min.css')

document.addEventListener('alpine:init', () => {

    Alpine.data('new_edit_content_insertion_x_data', () => withConversionAlert({
        init() {
            this.content_name = this.$refs.edit_content_insertion_data.dataset.contentName
            this.content_type = this.$refs.edit_content_insertion_data.dataset.contentType
            this.pre_roll_all = this.$refs.edit_content_insertion_data.dataset.pre === 'true'
            this.post_roll_all = this.$refs.edit_content_insertion_data.dataset.post === 'true'
            const audio_url = this.$refs.edit_content_insertion_data.dataset.audio
            if (audio_url !== 'null') {
                console.log(audio_url)
                let audio_div = document.getElementById('ql-uploaded-audio-insert')
                audio_div.setAttribute('src', audio_url)
                audio_div.load()
                this.audio_upload = 'yes'
            }

            // No need to do a check like in 'new' since this is a single page and not broken into sections
            uppy_content_insertion(this)

            this.episode_data = JSON.parse(this.$refs.episode_data.dataset.episodes).map(mapPlacementEpisode)

            console.log('this.episode_data', this.episode_data)

            this.content_insertion_id = this.$refs.edit_content_insertion_data.dataset.content
            this.$watch('content_insertions', (val) => {
                console.log(val)
            })
            this.$watch('pre_roll_all', (val) => {
                let that = this
                if (val === false) {
                    // Iterate through content_insertions object and delete the values which contain the string 'pre_roll'
                    Object.keys(this.content_insertions).forEach(function (key) {
                        if (that.content_insertions[key].includes('pre_roll')) {
                            delete that.content_insertions[key]
                        }
                    })

                }
                that._clean_content_insertion_empty_values()
            })
            this.$watch('post_roll_all', (val) => {
                let that = this
                if (val === false) {
                    // Iterate through content_insertions object and delete the values which contain the string 'post_roll'
                    Object.keys(this.content_insertions).forEach(function (key) {
                        console.log(that.content_insertions[key])
                        if (that.content_insertions[key].includes('post_roll')) {
                            delete that.content_insertions[key]
                        }
                    })
                }
                that._clean_content_insertion_empty_values()
            })

            this.$watch('search_string', (val) => {
                if (val.length === 0) {
                    this.in_search_mode = false;
                    this.current_page = 0;
                    this.$refs.clear_button.classList.add("hidden")
                } else {
                    this.in_search_mode = true;
                    this.current_page = 0;
                    this.search_episode_data = this.episode_data.filter(episode => episode.title.toLowerCase().includes(val.toLowerCase()))
                    this.$refs.clear_button.classList.remove("hidden")
                }
                this.update_page_component()
                this.load_data_on_page();
            })

            this.$watch('current_page', (val) => {
                this.refresh_content_insertions()
            })

            this.setup_initial_table();
        },
        content_name: '',
        audio_upload: 'no',
        content_type: '',
        search_string: '',
        episode_data: [], //This holds the data for the episodes from the backend
        search_episode_data: [], // This holds the data for the episodes when searched
        current_page_episode_data: [], // This holds the data for the episodes of the current page
        content_insertions: [], // This holds the content insertions for the episode
        content_insertion_id: null,
        new_audio_uploaded: false,
        pre_roll_all: false,
        post_roll_all: false,
        bulk_add_pre_post_modal: false,
        selected_pre_post_text: '',
        selected_pre_post_header: '',
        selected_pre_post_option: '',
        max_items_per_page: 5,
        pages: 0,
        current_page: 0,
        in_search_mode: false,
        setup_initial_table() {
            this.pages = Math.ceil(this.episode_data.length / this.max_items_per_page);
            this.load_data_on_page();
        },
        update_page_component() {
            if (this.in_search_mode) {
                this.pages = Math.ceil(this.search_episode_data.length / this.max_items_per_page);
            } else {
                this.pages = Math.ceil(this.episode_data.length / this.max_items_per_page);
            }
        },
        page_items() {
            return pageWindowItems(this.pages, this.current_page)
        },
        go_to_page(page) {
            if (!Number.isInteger(page) || page < 0 || page >= this.pages) return
            this.current_page = page
            this.load_data_on_page()
        },
        load_data_on_page() {
            let that = this;
            let episode_data_to_load;
            if (that.in_search_mode) {
                episode_data_to_load = that.search_episode_data
            } else {
                episode_data_to_load = that.episode_data
            }
            const startIndex = that.current_page * that.max_items_per_page;
            let endIndex = null;
            if ((startIndex + that.max_items_per_page) >= episode_data_to_load.length) {
                endIndex = episode_data_to_load.length;
            } else {
                endIndex = startIndex + that.max_items_per_page
            }
            this.current_page_episode_data = [];

            for (let i = startIndex; i < endIndex; i++) {
                that.current_page_episode_data.push(episode_data_to_load[i])
            }
        },
        refresh_content_insertions() {
            this.content_insertions = [...this.content_insertions]
        },
        format_episode_season(episode) {
            if (episode.episode_season === 'null' && episode.episode_number === 'null') {
                return ''
            } else if (episode.episode_season === 'null' && episode.episode_number !== 'null') {
                return `E${episode.episode_number}`
            } else if (episode.episode_season !== 'null' && episode.episode_number === 'null') {
                return `S${episode.episode_season}`
            } else {
                return `S${episode.episode_season}:E${episode.episode_number}`
            }
        },
        display_pre_content(episode) {
            if (this.check_content_length(episode)) {
                let data = episode.content.filter((content) => {
                    return content.placement.toLowerCase() === 'pre'
                })

                if (data.length > 0) {
                    return data
                } else {
                    return [{id: null, content: 'No content', placement: null}]
                }

            } else {
                return [{id: null, content: 'No content', placement: null}]
            }
        },
        display_post_content(episode) {
            if (this.check_content_length(episode)) {
                let data = episode.content.filter((content) => {
                    return content.placement.toLowerCase() === 'post'
                })

                if (data.length > 0) {
                    return data
                } else {
                    return [{id: null, content: 'No content', placement: null}]
                }
            } else {
                return [{id: null, content: 'No content', placement: null}]
            }
        },
        check_content_length(episode) {
            return episode.content.length > 0
        },
        same_pre_post_roll(episode) {
            let that = this;
            if (this.check_content_length(episode)) {
                let pre_roll = that.display_pre_content(episode)[0]
                let post_roll = that.display_post_content(episode)[0]
                if (pre_roll && post_roll) {
                    return (pre_roll.content_id === post_roll.content_id) && (pre_roll.content_id !== null) && (post_roll.content_id !== null)
                } else {
                    return false
                }
            } else {
                return false
            }
        },
        capitalize(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        },
        _has_pre_roll_data() {
            // Check to see if episode data content has placement of pre_roll
            let that = this
            let has_pre_roll = false
            that.episode_data.forEach((episode) => {
                episode.content.forEach((content) => {
                    if (content.placement === 'pre') {
                        has_pre_roll = true
                    }
                })
            })
            return has_pre_roll
        },
        _has_post_roll_data() {
            // Check to see if episode data content has placement of pre_roll
            let that = this
            let has_post_roll = false
            that.episode_data.forEach((episode) => {
                episode.content.forEach((content) => {
                    if (content.placement === 'post') {
                        has_post_roll = true
                    }
                })
            })
            return has_post_roll
        },
        toggle_bulk_add_modal(data) {
            this.selected_pre_post_option = data
            if (data === 'pre-roll') {
                this.bulk_add_pre_post_modal = true
                if (this._has_pre_roll_data()) {
                    this.selected_pre_post_header = "Some Episodes Already Have Content!"
                    this.selected_pre_post_text = "Do you wish to replace the content in your selected episodes?"
                } else {
                    this.selected_pre_post_header = "Confirm action"
                    this.selected_pre_post_text = "This action will add/remove all the selected pre-rolls. Are you sure?"
                }
            }

            if (data === 'post-roll') {
                this.bulk_add_pre_post_modal = true
                this.bulk_add_pre_post_modal = true
                if (this._has_post_roll_data()) {
                    this.selected_pre_post_header = "Some Episodes Already Have Content!"
                    this.selected_pre_post_text = "Do you wish to replace the content in your selected episodes?"
                } else {
                    this.selected_pre_post_header = "Confirm action"
                    this.selected_pre_post_text = "This action will add/remove all the selected post-rolls. Are you sure?"
                }
            }

        },
        bulk_add_pre_post_data() {
            // This method takes the episode id from episode_data and adds it to the content_insertions array in the format of episode_id:pre_roll:add
            let that = this
            let selected_pre_post = that.selected_pre_post_option.replace("-", "_")
            that.episode_data.forEach((episode) => {
                that.content_insertions.push(episode.id + ':' + selected_pre_post + ':add')
            })
            console.log('selected_pre_post', selected_pre_post)
            if (selected_pre_post === 'pre_roll') {
                if (that.pre_roll_all === true) {
                    that.pre_roll_all = false
                } else {
                    that.pre_roll_all = true
                }
            } else if (selected_pre_post === 'post_roll') {
                if (that.post_roll_all === true) {
                    that.post_roll_all = false
                } else {
                    that.post_roll_all = true
                }
            }
            this._clean_content_insertion_empty_values()
            this._remove_duplicate_content_insertions()
            this.bulk_add_pre_post_modal = false
        },
        _clean_content_insertion_empty_values() {
            // This method removes any empty values from the content_insertions array
            let that = this
            that.content_insertions = that.content_insertions.filter((value) => {
                return value !== ''
            })
        },
        _remove_duplicate_content_insertions() {
            // This method removes any duplicate values from the content_insertions object
            let that = this
            that.content_insertions = that.content_insertions.filter((value, index, self) => {
                return self.indexOf(value) === index
            })
        },
        validate_content_name() {
            if (this.content_name.trim().length === 0) {
                alert('Content name is valid');
                return false;
            }
            if (this.content_type.trim().length === 0) {
                alert('Content type is valid');
                return false;
            }
            return true;
        },
        // Need to combine below functions since we only have 1 "save" button
        submit_content_name: function () {
            if (this.validate_content_name()) {
                let that = this
                let submit_url = this.$refs.edit_content_insertion_data.dataset.update;
                console.log(submit_url)
                fetch(submit_url, {
                    headers: {
                        "Content-Type": "application/json"
                    },
                    method: "PATCH",
                    body: JSON.stringify({
                        authenticity_token: document.querySelector('meta[name="csrf-token"]').content,
                        content_insertion: {
                            content_name: that.content_name,
                            content_type: that.content_type,
                            new_audio_uploaded: that.new_audio_uploaded,
                            content_insertions: that.content_insertions,
                            pre_roll_all: that.pre_roll_all,
                            post_roll_all: that.post_roll_all,
                        }
                    })
                })
                    .then(response => response.json())
                    .then(data => {
                        if (data.success) {
                            window.location.assign(data.url)
                        }
                    })
            }
        },
        save_as_draft_and_unpublish() {
            let that = this
            let save_as_draft_url = this.$refs.edit_content_insertion_data.dataset.saveAsDraftUrl;

            // let conf = confirm('Are you sure you want to set this content insertion as a draft? \n\nThis will remove all the content locations you have added below and remove the content from episodes.');
            //
            // if (conf) {
            //
            // }
            fetch(save_as_draft_url, {
                headers: {
                    "Content-Type": "application/json"
                },
                method: "PATCH",
                body: JSON.stringify({
                    authenticity_token: document.querySelector('meta[name="csrf-token"]').content,
                    content_insertion: {
                        save_as_draft: true,
                        content_insertions: that.content_insertions,
                        new_audio_uploaded: that.new_audio_uploaded,
                        pre_roll_all: that.pre_roll_all,
                        post_roll_all: that.post_roll_all,
                    }
                })
            })
                .then(response => response.json())
                .then(data => {
                    if (data.success) {
                        window.location.assign(data.url)
                    }
                })
        }
    }))
})

function uppy_content_insertion(alpine) {

    let signature = document.getElementById('ql-data-points').dataset.signature
    let location = document.getElementById('ql-data-points').dataset.storage
    let template_id = document.getElementById('ql-data-points').dataset.template

    const uppy = new Uppy({
        id: 'uppy_content_insertion',
        debug: true,
        autoProceed: true,
        restrictions: {
            maxFileSize: 150 * 1024 * 1024,
            minFileSize: 1,
            maxTotalFileSize: 150 * 1024 * 1024,
            maxNumberOfFiles: 1,
            minNumberOfFiles: 1,
            allowedFileTypes: AUDIO_ALLOWED_FILE_TYPES,
            requiredMetaFields: [],
        },
        locale: {
            strings: {
                youCanOnlyUploadFileTypes: AUDIO_ALLOWED_FILE_TYPES_MESSAGE,
            },
        },
    })

    // Preprocessor blocks autoProceed uploads until async stereo validation completes.
    registerStereoAudioPreProcessor(uppy)


    uppy.use(Dashboard, {
        trigger: document.getElementById('content-uppy-trigger'),
        closeAfterFinish: true,
        showProgressDetails: true,
        note: 'Audio files should be 150 MB or less.'
    })

    // uppy.use(Transloadit, {
    //     service: 'https://api2.transloadit.com',
    //     params: {
    //         auth: {
    //             key: signature,
    //         },
    //         template_id: template_id
    //     },
    //     waitForEncoding: true,
    //     waitForMetadata: true,
    //     importFromUploadURLs: false,
    //     alwaysRunAssembly: false,
    //     fields: {
    //         'location': location,
    //     },
    // })

    const show_id = document.getElementById('ql-data-points').dataset.show;
    const content_insertion_id = document.getElementById('ql-data-points').dataset.content

    uppy.use(AwsS3, {
        async getUploadParameters(file) {
            return fetch(`/shows/${show_id}/content-insertions/${content_insertion_id}/generate-content-insertion-upload-url`, {
                method: 'POST',
                headers: {
                    accept: "application/json",
                    "Content-Type": "application/json",
                    "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
                        .content,
                },
                body: JSON.stringify({
                    content_type: file.type,
                }),
            })
                .then((response) => {
                    return response.json();
                })
                .then((data) => {
                    return {
                        method: "PUT",
                        url: data.presigned_url_data[0],
                        fields: {},
                        headers: data.presigned_url_data[1],
                    };
                });
        }
    })

    uppy.on('upload', (data) => {
    })

    uppy.on('upload-error', (file, error, response) => {
        if (isStereoValidationFailureError(error)) {
            return
        }

        if (error.isNetworkError) {
            // Let your users know that file upload could have failed
            // due to firewall or ISP issues
            alert("The audio file was not uploading\n\n" +
                "If you are uploading from an office network, please check with your IT department regarding firewall settings. \n\n" +
                "Error: " + error.message)
        } else {
            alert("The audio file was not uploaded\n\n" + "Please check your internet connection and try again")
        }
    })


    uppy.on('complete', async (result) => {
        for (const file of result.successful) {
            const audio_download_url = await getAudioPreviewLink(file)
            let audio_div = document.getElementById('ql-uploaded-audio-insert')
            audio_div.setAttribute('src', audio_download_url.download_url)
            audio_div.load()
            alpine.new_audio_uploaded = true
            alpine.audio_upload = 'yes'
        }
        uppy.close()
        uppy_content_insertion(alpine)
    })

    async function getAudioPreviewLink(file) {
        return fetch(`/shows/${show_id}/content-insertions/${content_insertion_id}/generate-content-insertion-download-url`, {
            method: 'POST',
            headers: {
                accept: "application/json",
                "Content-Type": "application/json",
                "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
                    .content,
            },
            body: JSON.stringify({
                content_type: file.type,
            })
        })
            .then((response) => {
                return response.json();
            })
            .then((data) => {
                return data;
            })
            .catch((error) => {
                console.log(error);
            });
    }
}

function handleAudioDuration() {
    const audio_div = document.getElementById('ql-uploaded-audio-insert')
    const time_div = document.getElementById('audio-play-time')
    time_div.innerHTML = "00:00/00:00"
    audio_div.addEventListener("timeupdate", () => {
        time_div.innerHTML = convertSeconds(audio_div.currentTime) + '/' + convertSeconds(audio_div.duration);
    })
}

function convertSeconds(seconds) {
    if (seconds >= 3600) {
        return new Date(seconds * 1000).toISOString().slice(11, 19);
    } else {
        return new Date(seconds * 1000).toISOString().slice(14, 19);
    }
}
